import { AuthService } from "@mindmemobile/mm-shared-global";
import {
  MainLibrary,
  MediaItem,
  MediaType,
} from "@mindmemobile/mm-shared-library";
import React from "react"; 

type IProps = {
  onMediaItemClick: (mediaItem: MediaItem) => void;
  showUpload?: boolean;
  subAccountId: string;
  parentAccountId: string;
  userId: string;
  bearerToken: string;
  apiBaseURL: string;
  allowedMediaTypes?: (keyof typeof MediaType)[];
};

const SharedLibrary: React.FC<IProps> = ({
  onMediaItemClick,
  showUpload,
  subAccountId,
  parentAccountId,
  userId,
  bearerToken,
  apiBaseURL,
  allowedMediaTypes,
}) => {
  return (
    <MainLibrary
      isPrimarySubAccount={AuthService.isPrimarySubAccount}
      hasManagePermissions={AuthService.hasLibraryManagePermissions}
      subAccountId={subAccountId}
      parentAccountId={parentAccountId}
      userId={userId}
      bearerToken={bearerToken}
      apiBaseURL={apiBaseURL}
      handleAuth={true}
      onMediaItemClick={(mediaItem) => onMediaItemClick(mediaItem)}
      isMainLibraryView={false}
      isBuilderElementView={true}
      showUpload={showUpload}
      allowedMediaTypes={allowedMediaTypes}
    />
  );
};

export default SharedLibrary;
